var render = function render(){var _vm=this,_c=_vm._self._c;return _c('small',{style:(_vm.computedStyle)},[_vm._v("(UTC"),(_vm.fusoHorario != 'UTC')?_c('span',[_vm._v(_vm._s(_vm._fusoHorario))]):_c('span'),_vm._v(")")])
}
var staticRenderFns = []

export { render, staticRenderFns }